/* Tracking Scripts */
loadGTMScript('GTM-MDQ6HJ7');
/* Fraud Blocker */
loadScriptCMM(
  'https://monitor.fraudblocker.com/fbt.js?sid=6hcQEaryTQ-_tqJ0QH3hF',
);
/* Window Treatment Interactions Script */
loadAmplifyInteractionsScript(
  'https://grow.creekmoremarketing.com/embed/v6/160523708283626/1/1335916980/39b1c81e039cdc0845b741d4e13a26ab05a82dd4d3605af3',
);
/* Google Ads Conversions */
loadGoogleAdsConversions({
  account: 'AW-11342108503',
  enhanced_conversions: true,
  conversions: [
    {
      label: 'gMchCNeW1uMYENeuq6Aq',
      selector: 'form_submission',
      trigger: 'lead',
      enhancedConversionMapping: true,
    },
    {
      label: '82SiCNqW1uMYENeuq6Aq',
      adConversionType: 'directions',
    },
    {
      label: 'CtdiCNa11-MYENeuq6Aq',
      phoneConversionNumber: '(360) 676-5223',
    },
  ],
});

/* Header Contact Banner */
CMMBanner.make(
  [
    {
      text: [
        {
          content:
            'Proudly serving Bellingham, Washington (WA), and the surrounding areas',
        },
      ],
    },
    {
      text: CMMBanner.createSimpleButtons([
        CMMBanner.Button.Presets.DIRECTIONS({
          link: 'https://www.google.com/maps/search/?api=1&query=Walls+%26+Windows+4131+Hannegan+Rd+Ste+104%2CBellingham%2CWA+98226-7766',
        }),
        CMMBanner.Button.Presets.PHONE({
          text: '(360) 676-5223',
          link: 'tel:+13606765223',
        }),
      ]),
    },
  ],
  {
    presets: [CMMBanner.Presets.HEADER_CONTACT],
  },
);

/* Site-Wide Banner */
deferJQuery(function () {
  headerBannerMultipleColumns(
    [
      {
        text: "<a style='font-weight:600;' href='/more-products-services/products/awnings'>Awnings</a>, <a style='font-weight:600;' href='/more-products-services/products/roll-shutters'> Roll Shutters</a>, and <a style='font-weight:600;' href='/more-products-services/products/motorized-window-coverings'>Motorized Window Coverings</a>.",
        bgColor: '',
        txtColor: '#fff',
        linkColor: '#fff',
        border: '0',
        column_min_width: '50%',
        classname: '',
      },
      {
        text: "<a style='font-weight:600;' href='https://www.wallsandwindowsinc.com/more-products-services/products/roll-shutters'>Check out our new roller shutters and security screens from QMI, designed with quality and durability mind</a>.",
        bgColor: '#F5842A',
        txtColor: '#fff',
        linkColor: '#fff',
        border: '0',
        column_min_width: '50%',
        classname: '',
      },
      {
        text: '<h2>Request a Consultation <cmm-button-inject></cmm-button-inject></h2><h4>Proudly serving Bellingham, Washington (WA), and the surrounding areas</h4>',
        buttons: [
          {
            title: '(360) 676-5223',
            link: 'tel:+13606765223',
            class_list: ['cmm-button', 'cmm-button-hd-colors'],
          },
          {
            title: 'Leave a Review',
            link: 'https://grow.creekmoremarketing.com/walls-amp-windows-160523708283626/review-us?dashboard=1',
            link_target: '_blank',
            class_list: [
              'cmm-button',
              'cmm-button-gray-black',
              'cmm-leave-a-review',
            ],
          },
          {
            title: 'Directions',
            link: 'http://www.google.com/maps/search/?api=1&query=Walls+%26+Windows+4131+Hannegan+Rd+Ste+104%2CBellingham%2CWA+98226-7766',
            link_target: '_blank',
            class_list: ['cmm-button', 'cmm-button-gray-black'],
          },
        ],
        bgColor: '#fafafa',
        txtColor: '#000',
        border: '0',
        padding: '1rem',
        classname: '',
      },
    ],
    {
      padding: '1rem 0 0',
      border: {
        border_bottom: '1px solid #ddd',
      },
      column_min_width: '100%',
      classname: 'cmm-header-banner-fullwidth',
    },
  );
  /* HomePage Slider Houzz Logo */
  jQuery(document).ready(function () {
    jQuery('.slick-slide .background').append(
      '<div class="houzz-logo"><a href="https://www.houzz.com/pro/wallsandwindowswa/walls-and-windows" target="_blank"><img src="https://st.hzcdn.com/static/badge125_125@2x.png" alt="Walls and Windows in Bellingham, WA on Houzz" width="96" height="96" border="0" /></a></div>',
    );
  });
  cmmSetupEventTracking([
    {
      selector: 'a.now-hiring',
      action: 'Call (360) 676-5223 - Now Hiring Banner',
      event: 'click',
    },
  ]);
});

/* Smooth Scrolling */
cmmSmoothScrollInit();

/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      icon_size: 'wti',
      font: {
        family: 'AUTO',
      },
      text: '',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop', 'tablet', 'mobile'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:200px;" src="https://assets.hunterdouglas.com/content/dam/dealer-logos/w/walls---windows-10017603/web-10017603.png">',
    header_color: '#ffffff',
    description_text:
      'Ready to transform your space?<br>Our design team is here to help!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(360) 676-5223',
        link: 'tel:+13606765223',
        txt_color_hover: '#83C0DD',
        bg_color: '#83C0DD',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'https://www.google.com/maps/place/Walls+%26+Windows/@48.7912121,-122.443108,17z/data=!3m1!4b1!4m5!3m4!1s0x5485a38c083ea463:0x44026eb856db386c!8m2!3d48.7912121!4d-122.443108',
        link_target: '_blank',
        txt_color_hover: '#83C0DD',
        bg_color: '#83C0DD',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'REQUEST A CONSULTATION',
        link: '/request-consultation',
        bg_color: '#83C0DD',
        txt_color_hover: '#83C0DD',
        class_list: ['request-consultation'],
        icon: 'email',
      },
    ],
    footer_text:
      'Walls & Windows aims to be your Window Fashions dealer and local source for Window Treatments, Motorized Window Coverings, Awnings, Cornices, Fabrics, Roll Shutters, and Exterior Shades!',
    footer_color: '#3A3A3C',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call (360) 676-5223 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .request-consultation',
      action: 'Request a Consultation - ConvertBoost©',
      event: 'click',
    },
  ]);
});
/* Leave a Review Button */
if (['about', 'request-consultation', 'contact'].includes(strPath)) {
  deferJQuery(function () {
    headerBannerMultipleColumns(
      [
        {
          text: "<a class='cmm-button cmm-leave-a-review' target='_blank' href='https://grow.creekmoremarketing.com/walls-amp-windows-160523708283626/review-us?dashboard=1'>LEAVE A REVIEW</a>",
          bgColor: '#fff',
          linkColor: '#fff',
          linkHoverColor: '#fff',
          padding: '0',
          margin: '0',
        },
      ],
      {
        bgColor: '#fff',
        column_min_width: '100%',
        padding: '0',
        margin: '15px 0',
        selector:
          '.cmm-path-about #about .cmp-button-wrapper, .cmm-path-request-consultation #cmm-leave-a-review .cmp-text, .cmm-path-contact #cmm-leave-a-review .cmp-text',
        position: 'after',
      },
    ).then(() => {
      cmmSetupEventTracking([
        {
          selector: 'a.cmm-leave-a-review',
          action: 'Leave a Review - Amplify Button',
          event: 'click',
        },
      ]);
    });
  });
}
/* Custom Event Tracking */
cmmSetupEventTracking([
  {
    selector: '.cmp-navigation__item a[href="/request-consultation"]',
    action: 'Request Consultation - Menu',
    event: 'click',
  },
]);
/* Temporary Redirects
cmmRedirect({
    "": [
        "/more-products-services/products/exterior-shades",
        ]
});
*/

/* Set max numbe of reviews to show before slider */
cmmSetNumReviewsStatic(10);
cmmShuffleReviews();

// Review Button Fixes
cmmReviewButtonsFix(
  ['reviews'],
  'https://grow.creekmoremarketing.com/walls-amp-windows-160523708283626',
);

/* Site-Wide Footer Blurb */
var txtFooter =
  'We are a local window fashions dealer who specializes in the full selection of Hunter Douglas window treatments, including horizontal blinds, vertical blinds, roman shades, roller shades, sheer shadings, honeycomb cellular shades, plantation shutters, and motorized window treatments. Our showroom is located in Bellingham, Washington, but we also proudly serve Whatcom, Anacortes, Skagit and Island counties in WA.';
footerBlurb(txtFooter);

/* Custom Metadata */
cmmUpdateMetadata({
  'hunter-douglas/shades/sheer-shades': {
    t: 'Hunter Douglas Sheer Shades | Walls & Windows',
    d: 'Enjoy Hunter Douglas sheer shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shades/cellular-shades': {
    t: 'Hunter Douglas Cellular Shades | Walls & Windows',
    d: 'Upgrade your home with honeycomb shades like Hunter Douglas Cellular Shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shades/roman-shades': {
    t: 'Hunter Douglas Roman Shades | Walls & Windows',
    d: 'Learn more about Hunter Douglas Roman Shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shades/roller-shades': {
    t: 'Hunter Douglas Roller Shades | Walls & Windows',
    d: 'Find the perfect shades with Hunter Douglas Roller and Solar Shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shades/woven-shades': {
    t: 'Hunter Douglas Woven Shades | Walls & Windows',
    d: 'Also known as bamboo shades, learn more about Hunter Douglas Woven Shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shades/vertical-shades': {
    t: 'Vertical Shades | Walls & Windows',
    d: 'Learn about the benefits of Hunter Douglas Vertical Shades near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/shutters': {
    t: 'Hunter Douglas Shutters | Walls & Windows',
    d: 'Commonly known as plantation shutters, learn about Hunter Douglas Shutters Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/blinds/vertical-blinds': {
    t: 'Hunter Douglas Vertical Blinds | Walls & Windows',
    d: 'Learn more about stylish options like Hunter Douglas Vertical Blinds near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/blinds/wood-blinds': {
    t: 'Hunter Douglas Wood Blinds | Walls & Windows',
    d: 'Enjoy the natural beauty of Hunter Douglas Wood Blinds near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/blinds/metal-blinds': {
    t: 'Hunter Douglas Metal Blinds | Walls & Windows',
    d: 'Also known as aluminum blinds, learn more about Hunter Douglas Metal Blinds near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/powerview-automation': {
    t: 'Hunter Douglas PowerView® Automation | Walls & Windows',
    d: 'Modernize your home with motorized blinds, also known as automatic blinds. Learn more about motorized window treatments near Bellingham and Whatcom, Washington.',
  },
  'hunter-douglas/featured/room-darkening': {
    t: 'Room Darkening | Walls & Windows',
    d: 'Find room-darkening shades and blackout curtains for your home! Contact us near Bellingham, Whatcom, Skagit and Island counties, Washington to learn more today!',
  },
  'hunter-douglas/featured/energy-efficient': {
    t: 'Energy Efficiency | Walls & Windows',
    d: 'Create a more energy-efficient home with Walls & Windows. Our Hunter Douglas window treatments near Bellingham, Washington can also help lower your monthly energy bill.',
  },
  'hunter-douglas/featured/light-enhancing': {
    t: 'Light Enhancing | Walls & Windows',
    d: 'Enjoy more light in your home with Hunter Douglas window treatments near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/featured/door-coverings': {
    t: 'Door Covering | Walls & Windows',
    d: 'Find the ideal door cover or room divider with Hunter Douglas Window Treatments near Bellingham, Whatcom, Skagit and Island counties, Washington.',
  },
  'hunter-douglas/featured/sound-absorption': {
    t: 'Sound Absorption | Walls & Windows',
    d: "Increase your home's comfort with sound-absorbing window treatments from Hunter Douglas. Contact us near Bellingham and Whatcom, Washington to learn more today!",
  },
  'hunter-douglas/featured/top-down-bottom-up-shades': {
    t: 'Top-Down, Bottom-Up | Walls & Windows',
    d: 'Enjoy privacy and light control in your home with Top-Down, Bottom-Up window treatments from Hunter Douglas. Contact us near Bellingham, Washington to learn more!',
  },
});
